module.exports = __webpack_public_path__ + "static/media/belief-2.cfb3490f.jpg";